// extracted by mini-css-extract-plugin
export default {"container":"MobileHeader_container__zieGr","container__h1":"MobileHeader_container__h1__sGY3w","appear":"MobileHeader_appear__C-dGe","openTop":"MobileHeader_openTop__vq3js"};